<template>
  <a-card class="style1">
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminCreateCareSpeakerBio' })">Create Speaker Bio</a-button>
    <a-table :loading="isLoading" :columns="columns" :data-source="careSpeakerBioData" size="middle" bordered rowKey="id">
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record.slug)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
      <div slot="name" slot-scope="record">
        <a href="javascript:;" @click="onEdit(record.slug)">{{ record.name }}</a>
      </div>
      <template slot="bio" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData } from '@/utils';
import AdminService from '@/services/AdminService';
import { includes } from 'lodash';
export default {
  data() {
    return {
      isLoading: true,
      careSpeakerBioData: [],
      careSpeakerBioList: [],
      columns: [
        {
          title: 'Name',
          key: 'name',
          width: 200,
          scopedSlots: {
            customRender: 'name',
          },
        },
        {
          title: 'Bio',
          key: 'bio',
          dataIndex: 'bio',
          scopedSlots: {
            customRender: 'bio',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (item.key !== 'operation') {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  watch: {
    careSpeakerBioList: {
      async handler(val) {
        this.careSpeakerBioData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async doInitData() {
      this.careSpeakerBioList = await AdminService.careSpeakerBio.getAll();
    },
    onEdit(careSpeakerBioSlug) {
      this.$router.push({ name: 'AdminCareSpeakerBioDetail', params: { careSpeakerBioSlug } });
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.careSpeakerBio.delete(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.name} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
